import LinearBuying from "./LinearBuying";

export default LinearBuying;
